export function getLocale() {
  const metaTag = document.head.querySelector("meta[name=rails-locale]");

  return (metaTag ? metaTag.getAttribute("content") : null)
}